'use strict';

const green = '30D159';
const grey = '3E3E40';

const line = (color) => {
  return `background:url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 5 38' width='5' height='38'><rect fill='%23${color}' y='9' width='1' height='18'/></svg>") repeat-x left 1px / 5px 38px`
}

const minimize = (_content) => {
  let content = _content;
  content = content.replace(/\/\*(?:(?!\*\/)[\s\S])*\*\/|[\r\n\t]+/g, '');
  content = content.replace(/ {2,}/g, ' ');
  content = content.replace(/ ([{:}]) /g, '$1');
  content = content.replace(/([;,]) /g, '$1');
  content = content.replace(/ !/g, '!');
  return content;
}

const style = `
  <style>
    .audio_title-inner{
      height: 101px;
      display: flex;
      padding: 12px 0;
      box-sizing: border-box;
      align-items: flex-end;
      justify-content: space-between;
      font-weight: 600;
      font-size: 11px;
      line-height: 13px;
      letter-spacing: 0.3em;
      text-transform: uppercase;
      user-select: none;
    }
    .audio_container{
      height: 101px;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
    
    
    .audio_button{
      width: 35px;
      height: 38px;
      display: block;
      border: none;
      padding: 10px;
      margin: 0 0 0 -10px;
      box-sizing: border-box;
      cursor: pointer;
      outline: none;
      background: none;
    }
    .audio_play-icon{
      width: 0;
      height: 0;
      display: inline-block;
      vertical-align: middle;
      border: 9px solid transparent;
      border-left: 15px solid #${green};
    }
    .audio_pause-icon{
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .audio_pause-icon:before, .audio_pause-icon:after{
      content: '';
      width: 4px;
      height: 100%;
      display: block;
      background-color: #${green};
    }
    
    
    .audio_progress-container{
      width: calc(100% - 25px);
      height: 38px;
      cursor: pointer;
      overflow: hidden;
      outline: none;
      ${line(grey)};
    }
    .audio_progress-line{
      width: 100%;
      height: 100%;
      transform: translate3d(-101%, 0, 0);
      overflow: hidden;
    }
    .audio_progress-line-inner{
      width: 100%;
      height: 100%;
      transform: translate3d(100%, 0, 0);
      ${line(green)};
    }
  </style>
`;

export default minimize(style);